module.exports = __webpack_public_path__ + "assets/img/banner.45485eb5.png";